import React from "react";

const OpenFormButton = ({ form: { url, label } }) => (
  <a href={`${url}?reload=true`}>{label}</a>
);

export default OpenFormButton;
